function n(n){return n&&n.ownerDocument||document}export{n as o};
